import { getStatusColor, getStatusIcon } from "../utils/functions";
import { StatusPillProps } from "../utils/types";
import { formatToTitleCase } from "../../../../../utils/functions/formatters";

export const StatusPill = ({ status, outerClassName }: StatusPillProps) => {
  return (
    <div
      className={`px-[6px] py-[4px] max-w-fit rounded-[6px] flex items-center gap-[4px] bg-pure-white dark:bg-pure-white-dk border border-border-gray dark:border-border-gray-dk shadow-xs-blur ${outerClassName}`}
    >
      {getStatusIcon(status)}
      <span className={`capitalize ${getStatusColor(status)}`}>{formatToTitleCase(status)}</span>
    </div>
  );
};
